import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { Navigate } from 'react-router-dom';
import { Eye, EyeOff, ArrowLeft } from 'lucide-react';
import './PortalLogin.css';

const PortalLogin = () => {
  const { user, loading, login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  if (loading) return <div className="portal-loading">Loading...</div>;
  if (user) return <Navigate to={user.role === 'admin' ? '/portal/admin' : '/portal/dashboard'} />;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      await login(email, password);
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === 'string' ? detail : 'Invalid email or password');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="portal-login-page" data-testid="portal-login-page">
      <div className="portal-login-card">
        <div className="portal-login-brand">
          <h1>The R6&#8482; Collective</h1>
          <p>Client Advisory Portal</p>
        </div>
        <form onSubmit={handleSubmit} className="portal-login-form" data-testid="login-form">
          {error && <div className="portal-login-error" data-testid="login-error">{error}</div>}
          <div className="portal-field">
            <label htmlFor="email">Email</label>
            <input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoComplete="email" data-testid="login-email" />
          </div>
          <div className="portal-field">
            <label htmlFor="password">Password</label>
            <div className="portal-password-wrapper">
              <input id="password" type={showPassword ? "text" : "password"} value={password} onChange={(e) => setPassword(e.target.value)} required autoComplete="current-password" data-testid="login-password" />
              <button type="button" className="portal-password-toggle" onClick={() => setShowPassword(!showPassword)} data-testid="toggle-password" aria-label={showPassword ? "Hide password" : "Show password"}>
                {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </div>
          </div>
          <button type="submit" disabled={submitting} className="portal-login-btn" data-testid="login-submit">{submitting ? 'Signing in...' : 'Sign In'}</button>
        </form>
        <p style={{ textAlign: 'center', marginTop: '1.25rem', fontSize: '0.85rem', color: '#5A6C8A' }}>
          Don't have an account? <a href="/portal/signup" style={{ color: '#C8963E', fontWeight: 600, textDecoration: 'none' }} data-testid="login-signup-link">Sign Up</a>
        </p>
        <a href="/" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.4rem', marginTop: '1rem', fontSize: '0.82rem', color: '#5A6C8A', textDecoration: 'none', fontWeight: 600, transition: 'color 0.2s' }} data-testid="return-home-btn"
          onMouseEnter={(e) => e.currentTarget.style.color = '#1B2A4E'}
          onMouseLeave={(e) => e.currentTarget.style.color = '#5A6C8A'}
        >
          <ArrowLeft size={14} /> Return to Home Page
        </a>
      </div>
    </div>
  );
};

export default PortalLogin;
